import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton som matchar AppLayouts struktur (sidebar + main).
 * Används som Suspense-fallback för app-routes så användaren ser
 * layout-skalet direkt under code-split-chunkladdning, istället för vit yta.
 */
export default function AppShellSkeleton() {
  return (
    <div className="flex min-h-screen overflow-x-hidden">
      {/* Sidebar skeleton (desktop) */}
      <aside className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0 lg:left-0 bg-sidebar p-4 gap-4">
        <Skeleton className="h-8 w-32 bg-sidebar-accent/40" />
        <div className="space-y-2 mt-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-full bg-sidebar-accent/30" />
          ))}
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 lg:pl-64 min-w-0 overflow-x-hidden">
        {/* Mobile header skeleton */}
        <header className="lg:hidden sticky top-0 z-40 flex h-16 items-center gap-4 border-b bg-background px-4">
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-6 w-28" />
        </header>

        <main className="p-4 sm:p-6 lg:p-8 space-y-6">
          <Skeleton className="h-9 w-1/3" />
          <Skeleton className="h-4 w-1/2" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-32 w-full" />
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
